import { Action } from '../plugins/history/index'

export class ControlValueAction extends Action {
  constructor(editor, _uid, prev, val, type) {
    super()
    this.editor = editor
    this._uid = _uid
    this.prev = prev
    this.val = val
    this.type = type
  }

  _setval(val) {
    const nodes = this.editor.nodes
    console.log(this.type)
    for (const index in nodes) {
      const node = nodes[index]

      switch (this.type) {
        case 'select':
          node.controls.forEach((control) => {
            if (this._uid === control.vueContext._uid) {
              control.setValue(val)
            }
          })
          break

        case 'input':
          node.inputs.forEach((input) => {
            if (input.control !== null) {
              if (this._uid === input.control.vueContext._uid) {
                input.control.setValue(val)
              }
            }
          })
          break
      }
    }
  }

  undo() {
    this._setval(this.prev)
  }

  redo() {
    this._setval(this.val)
  }

  update(editor, val) {
    if (this.prev !== val) {
      this.val = val
    } else {
      editor.produced.pop()
    }
  }
}
